<!-- Modal 编辑成员  -->
<template>
  <el-drawer
    size="25%"
    :modal="false"
    destroy-on-close
    :visible.sync="this.$store.state.Drawer_Member_Modify"
    :with-header="false"
    :before-close="closeDrawer"
    @open="opendrawer"
  >
    <div class="drawer" v-if="this.$store.state.Drawer_Member_Modify">
      <div class="drawer_header">
        <div class="header_title">
          编辑成员
          <div class="bgIMg"></div>
        </div>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div class="drawer_body">
        <div v-if="ModifyStatus == 0">
          <div class="body_title">
            <div class="title choose">
              基<span class="title_line">础信</span>息
            </div>
            <div
              class="title"
              @click="ModifyStatus = 1"
              v-if="
                chooseMemberMsg.rolesList_CODE.indexOf('master_admin') != -1 ||
                chooseMemberMsg.rolesList_CODE.indexOf('admin') != -1
              "
            >
              移交主管理员
            </div>
          </div>
          <div class="center_input">
            <div class="body_input">
              <div class="input_name"><span class="Required">*</span>姓名</div>
              <el-input
                class="input_input"
                v-model="username"
                placeholder="请输用户名"
              ></el-input>
            </div>
            <div class="body_input">
              <div class="input_name"><span class="Required">*</span>账号</div>
              <el-input
                class="input_input"
                v-model="account"
                placeholder="请输账号"
              ></el-input>
            </div>

            <div class="body_input">
              <div class="input_name">
                <span class="Required">*</span>手机号
              </div>
              <el-input
                readonly
                class="input_input"
                v-model="phone"
                placeholder="请输手机号"
                @focus="changPohne"
              ></el-input>
            </div>

            <div class="body_input">
              <div class="input_name">
                <span class="Required">*</span>所属部门
              </div>
              <el-input
                readonly
                class="input_input"
                v-model="deptNames"
                @focus="chooseDepartment"
              ></el-input>
            </div>

            <div class="body_input">
              <div class="input_name">
                <span class="Required">*</span>成员状态
              </div>
              <div class="input_radio">
                <el-radio v-model="state" label="0">停用</el-radio>
                <el-radio v-model="state" label="1">启用</el-radio>
              </div>
            </div>
            <!-- <div class="body_input">
              <div class="input_name"><span class="Required">*</span>角色</div>
              <el-select
                class="input_input"
                multiple
                v-model="RoleID"
                placeholder="请选择"
                v-defaultSelect="[selectedFood]"
              >
                <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                  :disabled="
                    item.roleId == 1 || item.roleId == 2 || item.roleId == 3
                  "
                >
                </el-option>
              </el-select>
            </div> -->
          </div>

          <div class="bottom_button">
            <div class="buttom_Del_line marin_l" @click="toDel">删除成员</div>
            <div class="buttom_Del marin_l" @click="toConfirm">确定</div>
          </div>
        </div>

        <div
          v-if="
            ModifyStatus == 1 &&
            (chooseMemberMsg.rolesList_CODE.indexOf('master_admin') != -1 ||
              chooseMemberMsg.rolesList_CODE.indexOf('admin') != -1)
          "
        >
          <div class="body_title">
            <div class="title" @click="ModifyStatus = 0">基础信息</div>
            <div class="title choose">
              移<span class="title_line">交主管理</span>员
            </div>
          </div>
          <div class="center_input">
            <div class="body_input">
              <div class="input_name">
                <span class="Required">*</span>主管理员
              </div>
              <el-input
                readonly
                class="input_input"
                v-model="username"
                placeholder="请输手机号"
                @focus="choosemember"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主管理员移交流程 -->
    <DialogAdminHandover :information="chooseMemberMsg"></DialogAdminHandover>

    <!-- 修改电话号码流程 -->
    <DialogChangePhone @newphone="getNewPhone"></DialogChangePhone>

    <ChangeDeptModal
      :visible="isShowDeptModal"
      :obj="deptObj"
      @closeModal="onCloseDeptModal"
    />
  </el-drawer>
</template>

<script>
import {
  authuserupdate,
  authrolelist,
  authuser,
  authuseruserId,
} from "../../../api/api";
import DialogAdminHandover from "./dialogPhone.vue";
import DialogChangePhone from "./changePhone.vue";
import ChangeDeptModal from "./changeDeptModal.vue";
export default {
  name: "Modifymember",
  props: ["chooseMemberMsg"],
  components: { DialogAdminHandover, DialogChangePhone, ChangeDeptModal },
  mounted() {},
  data() {
    return {
      userId: "",
      deptId: "", // 当前部门ID
      // 用户信息
      account: "",
      username: "",
      phone: "",
      Role: "",
      RoleID: [],
      roleList: [],
      selectedFood: [], //下拉选择禁止删除
      state: "0",
      deptNames: "", // 所属部门
      deptIds: "",
      ModifyStatus: 0, //当前的状态
      // 调整部门modal
      isShowDeptModal: false,
      deptObj: {},
    };
  },
  watch: {
    chooseMemberMsg(e) {
      this.RoleID = this.getNowRoleArr(e.roles);
    },
    // 当用户的所属部门发生变化后 重新请求用户信息并仅覆盖部门信息
    "$store.state.Dialog_Change_Dept"(e) {
      console.log("变化了", e);
      if (e) {
        // this.deptId = e.deptId;
        this.getUserMsg("reDept");
      }
    },
  },

  beforeDestroy() {
    this.selectedFood = [];
  },

  methods: {
    // 抽屉
    opendrawer() {
      this.selectedFood = [];
      this.userId = this.$props.chooseMemberMsg.userId;
      this.deptId = this.$props.chooseMemberMsg.deptId;
      this.getRoleList();
      this.getUserMsg();
    },
    closeDrawer() {
      this.ModifyStatus = 0;
      this.$store.commit("SET_Drawer_Member_Modify", false);
    },
    // 获取用户的信息
    getUserMsg(type) {
      let params = {
        deptId: this.deptId,
        userId: this.userId,
      };
      if (params.deptId && params.userId) {
        authuseruserId(params).then((res) => {
          if (res.code == 200) {
            let names = "";
            for (let i = 0, len = res.data.deptNames.length; i < len; i++) {
              names += i ? "，" + res.data.deptNames[i] : res.data.deptNames[i];
            }
            this.deptNames = names;
            this.deptIds = res.data.deptIds;
            if (type === "reDept") {
              return;
            }

            this.account = res.data.username;
            this.username = res.data.nickName;
            this.phone = res.data.phoneNumber;
            this.Role = res.data.roleName;
            this.state = res.data.status == "enable" ? "1" : "0";
          }
        });
      }
    },
    // 主管理员
    choosemember() {
      this.$store.commit("SET_Dialog_Admin_Handover", true);
    },
    // 手机号码
    getNewPhone(e) {
      this.phone = e;
    },
    changPohne() {
      this.$store.commit("SET_Dialog_Change_Phone", true);
    },
    // 调整成员部门 modal
    chooseDepartment() {
      // this.$store.commit("SET_Dialog_Adjust_Members", true);
      this.isShowDeptModal = true;
      this.deptObj = {
        type: "single",
        userIds: this.$props.chooseMemberMsg.userId,
        deptId: this.$props.chooseMemberMsg.deptId,
        chooseDept: this.deptIds,
      };
    },
    onCloseDeptModal(e) {
      // 刷新用户信息
      if (e.actionType === "confirm") {
        this.getUserMsg("reDept");
      }
      this.isShowDeptModal = false;
    },
    // 角色列表
    getNowRoleArr(data) {
      let arr = [];
      for (let i in data) {
        arr.push(data[i].roleId);
        if (data[i].roleId == 1 || data[i].roleId == 2 || data[i].roleId == 3) {
          this.selectedFood.push(i);
        }
      }
      return arr;
    },
    getRoleList() {
      authrolelist().then((res) => {
        if (res.code == 200) {
          this.roleList = res.data;
        }
      });
    },
    // 系统管理员
    addSystemAdmin(data) {
      this.$confirm("是否确定设定该用户为系统管理员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          userIds: [data.userId],
          type: "open",
        };
        authusersetsysAdmin(params).then((res) => {
          if (res.code == 200) {
            this.getUserListMethod();
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          }
        });
      });
    },
    delSystemAdmin(data) {
      this.$confirm("是否确定设定该用户为系统管理员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          userIds: [data.userId],
          type: "close",
        };
        authusersetsysAdmin(params).then((res) => {
          if (res.code == 200) {
            this.getUserListMethod();
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          }
        });
      });
    },
    // 删除成员
    toDel() {
      this.$confirm(
        "是否确认删除成员？删除后成员将不在公司的组织架构内。",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let params = {
          userIds: this.$props.chooseMemberMsg.userId,
        };
        authuser(params).then((res) => {
          if (res.code == 200) {
            this.$store.commit("SET_Refresh_UserList");
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          }
        });
      });
    },
    // 点击确定按钮
    toConfirm() {
      let params = {
        userId: this.$props.chooseMemberMsg.userId,
        nickName: this.username,
        userName: this.account,
        phoneNumber: this.phone,
        status: this.state == 0 ? "stopUsing" : "enable",
      };
      authuserupdate(params).then((res) => {
        if (res.code == 200) {
          this.closeDrawer();
          this.$store.commit("SET_Refresh_UserList");
          this.$notify.success({
            title: "成功",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  width: 100%;
  display: flex;
  flex-direction: column;

  cursor: pointer;
  user-select: none;
  .drawer_header {
    border-bottom: 0.125rem solid #eeeeee;
    height: 3.375rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.25rem;
    box-sizing: border-box;
    .header_title {
      font-weight: 400;
      font-size: 1rem;
      position: relative;
      .bgIMg {
        position: absolute;
        bottom: 0;
        left: -0.5rem;
        width: 6.25rem;
        height: 0.625rem;
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 0.5rem;
      }
    }
  }
  .drawer_body {
    padding: 1rem;

    .center_input {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .body_title {
      display: flex;
      .title {
        font-size: 0.875rem;
        color: #999999;
        margin-right: 1rem;
      }
      .title_line {
        border-bottom: 0.1875rem solid #b7282d;
      }
      .choose {
        color: #b7282d;
        font-weight: 600;
      }
    }
    .body_img {
      width: 5.5rem;
      height: 5.5rem;
      border-radius: 0.25rem;
      margin-top: 2rem;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .body_input {
      margin-top: 1.875rem;
      display: flex;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 2.5rem;
      .input_name {
        width: 5rem;
      }
      .input_input {
        width: 18.75rem;
      }
      .input_radio {
        width: 18.75rem;
        padding: 0 0.625rem;
        box-sizing: border-box;
      }
    }
    .body_bottom {
      display: flex;
      margin-top: 55vh;
      user-select: none;
      cursor: pointer;

      .body_conf {
        width: 4rem;
        height: 2rem;
        background: #b7282d;
        border-radius: 0.25rem;
        color: #ffffff;
        font-size: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1.875rem;
      }
      .body_delete {
        background: #ffffff;
        color: #b7282d;
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1.25rem;
        border: 0.0625rem solid #b7282d;
        border-radius: 0.25rem;
        height: 2rem;
        width: 5rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .bottom_button {
    width: 100%;
    bottom: 2rem;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .marin_l {
    margin-left: 0.75rem;
  }
}
</style>